import { graphql, useStaticQuery } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import React from "react"
import { Target } from "../../utils"
import FooterBase from "../shared/Footer"

const query = graphql`
  query {
    logo: file(relativePath: { eq: "nico/logo.png" }) {
      childImageSharp {
        gatsbyImageData(width: 100)
      }
    }
  }
`

const Footer = () => {
  const data = useStaticQuery(query)
  const items = {
    name: "nico",
    subName: "放課後等デイサービス",
    target: "nico" as Target,
    appNum: 1050600145,
    address: "〒378-0053 群馬県沼田市東原新町1838−3",
    tel: "0278-25-4970",
    fax: "0278-25-4971",
    logo: getImage(data.logo),
  }

  return <FooterBase {...items} />
}

export default Footer
